<template>
    <b-modal id="orderConfirmModal" title="주문 정보 확인" dialog-class="order_confirm_dialog" @show="onShow">
        <div class="search user_modal">
            <div class="table_list">
                <div class="title_sm pt0">
                    <h3 class="tb_title">주문 정보</h3>
                </div>
                <table class="write">
                    <colgroup>
                        <col width="150">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                          <th><span>처방명</span></th>
                          <td>
                            <span>{{ application.prescribe_nm }}</span>
                            <span v-if="showQuantity"> × {{ application.item_quantity }}</span>
                          </td>
                        </tr>
                        <tr>
                            <th><span>환자명</span></th>
                            <td>
                                <span>{{ application.patient_name }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="table_list">
                <div class="title_sm pt10 pb10">
                    <h3 class="tb_title">배송 정보</h3>
                </div>
                <table class="write">
                    <colgroup>
                        <col width="150">
                        <col width="*">
                    </colgroup>
                    <tbody>
                        <tr>
                            <th><span>받는사람</span></th>
                            <td><span>{{ application.receive_nm }}</span></td>
                        </tr>
                        <tr>
                            <th><span>연락처</span></th>
                            <td><span>{{ formatPhoneNumber(application.receive_phone_num) }}</span></td>
                        </tr>
                        <tr>
                            <th><span>주소</span></th>
                            <td><span>[{{ application.receive_post_no }}] {{ application.receive_addr }} {{ application.receive_addr_dtl }}</span></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <template #modal-footer>
            <b-button class="btn btn_md btn_gray" @click="fn_cancel">취소</b-button>
            <b-button class="btn btn_md btn_brown" @click="fn_confirm">확인</b-button>
        </template>
    </b-modal>
</template>

<script>
import commonUtil from "@/mixin/commonUtil";

export default {
    name: 'orderConfirmModal',
    mixins: [commonUtil],
    props: {
        application: {
            type: Object,
            default: () => ({})
        },
        showQuantity: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        deliveryTypeNm() {
            const deliveryTypeMap = {
                TTC: '탕전실 > 한의원',
                CTP: '한의원 > 환자',
                TTP: '탕전실 > 환자',
                TTT: '탕전실 직접수령',
                ETC: '직접입력'
            }

            return deliveryTypeMap[this.application.deliveryType] || ''
        }
    },
    methods: {
        onShow() {
        },
        fn_cancel() {
            this.$bvModal.hide('orderConfirmModal');
        },
        fn_confirm() {
            this.$bvModal.hide('orderConfirmModal');
            this.$emit('confirm');
        }
    }
}
</script>

<style scoped>
::v-deep .order_confirm_dialog {
    max-width: 400px;
}
</style>